import { useState, useCallback } from 'react';
import { DrgView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing DRG dialog state
 */
export function useDrgDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingDrg, setEditingDrg] = useState<DrgView | null>(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const handleAddDrg = useCallback(() => {
    setEditingDrg(null);
    setDialogOpen(true);
  }, []);

  const handleEditDrg = useCallback((drg: DrgView) => {
    setEditingDrg(drg);
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
    setEditingDrg(null);
  }, []);

  const handleOpenHelpDialog = useCallback(() => {
    setHelpDialogOpen(true);
  }, []);

  const handleCloseHelpDialog = useCallback(() => {
    setHelpDialogOpen(false);
  }, []);

  return {
    dialogOpen,
    editingDrg,
    helpDialogOpen,
    handleAddDrg,
    handleEditDrg,
    handleCloseDialog,
    handleOpenHelpDialog,
    handleCloseHelpDialog,
  };
}
